export const Images = {
    // svg images
    mgHeaderLogo: require("../asset/svg/mgHeaderLogo.svg").default,
    searchIcon: require("../asset/svg/searchIcon.svg").default,
    userIcon: require("../asset/svg/userIcon.svg").default,

    logoutIcon: require("../asset/svg/logoutIcon.svg").default,
    tennesBallIcon: require("../asset/svg/tennesBallIcon.svg").default,
    boxing: require("../asset/svg/boxing.svg").default,
    cricatIcon: require("../asset/svg/cricatIcon.svg").default,
    batBallIcon: require("../asset/svg/batBallIcon.svg").default,
    foodBallIcon: require("../asset/svg/foodBallIcon.svg").default,
    ballIcon: require("../asset/svg/ballIcon.svg").default,
    aTozIcon: require("../asset/svg/aTozIcon.svg").default,
    betIcon: require("../asset/svg/betIcon.svg").default,
    bonusIcon: require("../asset/svg/bonusIcon.svg").default,
    favoritesIcon: require("../asset/svg/favoritesIcon.svg").default,
    // liveIcon: require("../asset/svg/liveIcon.svg").default,
    liveIcon: require("../asset/img/liveImg.png"),
    homeIcon: require("../asset/svg/homeIcon.svg").default,

    sliderBannerImg1: require("../asset/svg/sliderBannerImg1.svg").default,
    sliderBannerImg2: require("../asset/svg/sliderBannerImg2.svg").default,
    sliderBannerImg3: require("../asset/svg/sliderBannerImg3.svg").default,

    sliderBanner2Img1: require("../asset/svg/sliderBanner2Img1.svg").default,
    sliderBanner2Img2: require("../asset/svg/sliderBanner2Img2.svg").default,
    sliderBanner2Img3: require("../asset/svg/sliderBanner2Img3.svg").default,

    flagIcon1: require("../asset/svg/flagIcon1.svg").default,
    flagIcon2: require("../asset/svg/flagIcon2.svg").default,
    tvBgImg: require("../asset/svg/tvBgImg.svg").default,

    cricatebatIcon: require("../asset/svg/cricatebatIcon.svg").default,
    cricateballIcon: require("../asset/svg/cricateballIcon.svg").default,

    whiteFootbalIcon: require("../asset/svg/whiteFootbalIcon.svg").default,
    whiteBatIcon: require("../asset/svg/whiteBatIcon.svg").default,
    vsIcon: require("../asset/svg/vsIcon.svg").default,
    footbalGroundBg: require("../asset/svg/footbalGroundBg.svg").default,
    cricatGroundBg: require("../asset/svg/cricatGroundBg.svg").default,
    whiteDownArrow: require("../asset/svg/downArrow.svg").default,
}